import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
export var switchTab = normalize.switchTab(function (options) {
  ks.switchTab(options);
}, CONTAINER_NAME.KWAI);
export default switchTab;